export default {"src":"/_next/static/media/arrow_left.57639fd2.svg","height":30,"width":30};